import { render, staticRenderFns } from "./news_school_list.vue?vue&type=template&id=4b06ac05&scoped=true&"
import script from "./news_school_list.vue?vue&type=script&lang=js&"
export * from "./news_school_list.vue?vue&type=script&lang=js&"
import style0 from "./news_school_list.vue?vue&type=style&index=0&id=4b06ac05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06ac05",
  null
  
)

export default component.exports